import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

class Sidebar extends Component {
  handleClick = (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle('open');
  };

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  };

  hasRoleSpec = (roles) => {
    return this.props.globals.hasRoleSpec(roles);
  };

  // secondLevelActive(routeName) {
  //   return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav nav-second-level collapse in' : 'nav nav-second-level collapse';
  // }

  getPublicUrl = (url) => {
    return this.props.globals.public_url.concat(url);
  };

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1
      ? 'nav-item nav-dropdown open'
      : 'nav-item nav-dropdown';
  }

  render() {
    return (
      <div className='sidebar'>
        <nav className='sidebar-nav'>
          <ul className='nav'>
            {this.hasRole(['DASHBOARD_DASHBOARD']) && (
              <li className='nav-item'>
                <NavLink
                  to={this.getPublicUrl('/admin/dashboard')}
                  className='nav-link'
                  activeClassName='active'
                >
                  <i className='icon-home' />
                  {'Dashboard'}
                </NavLink>
              </li>
            )}
            {
            this.hasRole(['ELOADAS_ELOADAS', 'MUSOR_MUSOR', 'MUSOR_TULAJDONSAG', 'JEGY_JEGY']) && 
              (
              <li className={this.activeRoute('/admin/esemenyek')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='fa fa-calendar-check-o' aria-hidden='true'></i>
                  Események
                </a>
                <ul className='nav-dropdown-items'>
                  {
                    this.hasRole(['ELOADAS_ELOADAS']) && 
                    (
                    <li className='nav-item'>
                      <NavLink to={this.getPublicUrl('/admin/esemenyek/eloadasok')} className='nav-link' activeClassName='active'>
                        &emsp;<i className='fa fa-film' />
                        Előadások
                        </NavLink>
                    </li>
                  )}
                  {
                    this.hasRole(['MUSOR_MUSOR', 'MUSOR_TULAJDONSAG']) &&
                     (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/esemenyek/musorok')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;<i className='fa fa-calendar' />
                          Műsorok
                        </NavLink>
                    </li>
                  )}
                  {
                    this.hasRole(['JEGY_JEGY']) && 
                    (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/esemenyek/jegytipusok')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;<i className='fa fa-ticket' />
                        Jegytípusok
                        </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {(this.hasRole(['TEREMBERLES_TEREMBERLES']) || this.hasRoleSpec(['TEREMBERLES_FIZ_KARB'])) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/teremberles')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        <i className='fa fa-ticket' />
                        Terembérlés
                        </NavLink>
                    </li>
            )}
            {
              (this.hasRole(['JEGYVASARLAS_RENDELES', 'JEGYVASARLAS_EMAILSABLON', 'JEGYVASARLAS_RENDELES_MUSOR']) || this.hasRoleSpec(['JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_XLSX',
              'JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_PDF', 'JEGYVASARLAS_RIPORT_FORGALOM_XLSX', 'JEGYVASARLAS_RIPORT_FORGALOM_PDF'])) && (
              <li className={this.activeRoute('/admin/jegyertekesites')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='fa fa-ticket' aria-hidden='true'></i>
                  Jegyértékesítés
                </a>
                <ul className='nav-dropdown-items'>
                {this.hasRole(['JEGYVASARLAS_RENDELES', 'JEGYVASARLAS_RENDELES_MUSOR']) && (
                    <li className='nav-item'>
                      <NavLink to={this.getPublicUrl('/admin/jegyertekesites/helysziniertekesites')} className='nav-link' activeClassName='active'>
                      <i className='fa fa-map-marker' aria-hidden='true'></i>
                        Helyszíni értékesítés
                      </NavLink>
                    </li>
                  )}
                  {this.hasRoleSpec(['JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_XLSX', 'JEGYVASARLAS_RIPORT_NEZOSZAMJELENTES_PDF', 'JEGYVASARLAS_RIPORT_FORGALOM_XLSX', 'JEGYVASARLAS_RIPORT_FORGALOM_PDF']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/jegyertekesites/lekerdezesek')}
                        className='nav-link'
                        activeClassName='active'
                      >
                          <i className='fa fa-line-chart' aria-hidden='true'></i>
                        Lekérdezések
                        </NavLink>
                    </li>
                  )}
                  {
                    this.hasRole(['JEGYVASARLAS_EMAILSABLON']) && 
                      (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/jegyertekesites/emailsablonok')}
                            className='nav-link'
                            activeClassName='active'
                          >
                              <i className='fa fa-pencil-square-o' aria-hidden='true'></i>
                            Email sablonok
                            </NavLink>
                        </li>
                      )
                  }
                </ul>
              </li>
            )}
            {this.hasRoleSpec(['JEGYVASARLAS_JEGYCONTROL']) && (
              <li className='nav-item'>
                <NavLink
                  to={this.getPublicUrl('/admin/jegyellenorzes')}
                  className='nav-link'
                  activeClassName='active'
                >
                  <i className='fa fa-barcode' aria-hidden='true'></i>
                  {'Jegyellenőrzés'}
                </NavLink>
              </li>
            )}        
            {((this.hasRole([
              'KESZLETNYILV_BEVETELEZES',
              'KESZLETNYILV_CSOKKENES',
              'KESZLETNYILV_SELEJTEZES',
              // 'KESZLETNYILV_LELTAR',
              'KESZLETNYILV_KESZLETINFO',
              'KESZLETNYILV_FORGALOM',
              'KESZLETNYILV_LELTAR'
            ]) /* || this.hasRoleUnique('ROLE_RAKTAR_RAKTARLISTA_LEK') */)
              ) && (
                <li className={this.activeRoute('/admin/keszlet')}>
                  <a
                    className='nav-link nav-dropdown-toggle nav-head'
                    onClick={this.handleClick.bind(this)}
                  >
                    <i className='icon-drawer' />
                    Készlet
                </a>
                  <ul className='nav-dropdown-items'>
                    {/* {this.hasRoleUnique('ROLE_RAKTAR_RAKTARLISTA_LEK') &&
                      (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/keszlet/raktarlista')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            <i className='fa fa-list' />
                            Raktárkészlet lista
                      </NavLink>
                        </li>
                      )} */}

                      {this.hasRole(['KESZLETNYILV_BEVETELEZES', 'KESZLETNYILV_CSOKKENES', 'KESZLETNYILV_SELEJTEZES', 'KESZLETNYILV_FORGALOM', 'KESZLETNYILV_LELTAR']) && (
                        <React.Fragment>
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/keszlet/keszletkezeles')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;&emsp;Készletkezelés
                          </NavLink>
                        </li>
                          {/* <li className='nav-item'>
                            <NavLink
                              to={this.getPublicUrl('/admin/keszlet/leltar')}
                              className='nav-link'
                              activeClassName='active'
                            >
                              &emsp;&emsp;Leltározás
                            </NavLink>
                          </li> */ }
                          </React.Fragment>
                      )}
                      {/* <li className="nav-item">
                        <NavLink
                          to={this.getPublicUrl("/admin/keszlet/leltar")}
                          className="nav-link"
                          activeClassName="active"
                        >
                          &emsp;&emsp;Leltározás
                        </NavLink>
                      </li> */}
                      {this.hasRole(['KESZLETNYILV_KESZLETINFO']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/keszlet/keszletinformacio')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;&emsp;Készletinformáció
                      </NavLink>
                        </li>
                      )}
                  </ul>
                </li>
            )}
            {(this.hasRole(['BUFE_BUFE', 'BUFE_KOZOS', 'BUFE_KINALAT', 'BUFE_NTAK_RMS_NAPLO']) || this.hasRoleSpec(['BUFE_FORGALOMOSSZ', 'BUFE_FORGALOMRESZ', 'BUFE_ELADASLISTA'])) && (
              <li className={this.activeRoute('/admin/bufe')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='fa fa-cutlery' />
                  Büfé
                </a>
                <ul className='nav-dropdown-items'>
                  {this.hasRole(['BUFE_BUFE']) && (
                      <li className='nav-item'>
                        <NavLink
                          to={this.getPublicUrl('/admin/bufe/ertekesites')}
                          className='nav-link'
                          activeClassName='active'
                        >
                          &emsp;<i className='fa fa-cutlery' />
                          {'Értékesítés'}
                        </NavLink>
                      </li>
                    )}
                  {this.hasRole(['BUFE_BUFE', 'BUFE_KOZOS', 'BUFE_KINALAT']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/bufe/termekek')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                        <i className='fa fa-cubes' aria-hidden='true'></i>
                          {'Termékek'}
                        </NavLink>
                    </li>
                  )}
                  {
                   this.hasRoleSpec(['BUFE_FORGALOMOSSZ', 'BUFE_FORGALOMRESZ']) && 
                    (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/bufe/forgalom')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                          <i className='fa fa-bar-chart' aria-hidden='true'></i>
                          {'Forgalom'}
                        </NavLink>
                    </li>
                  )}
                  {this.hasRoleSpec(['BUFE_ELADASLISTA']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/bufe/eladasilista')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                          <i className='fa fa-pie-chart' aria-hidden='true'></i>
                          {'Eladási lista'}
                        </NavLink>
                    </li>
                  )}
                  {this.hasRole(['BUFE_NTAK_RMS_NAPLO']) && (
                    <li className="nav-item">
                      <NavLink to={this.getPublicUrl('/admin/bufe/ntak')} className="nav-link" activeClassName="active">
                        &emsp;
                        <i className="fa fa-bar-chart" aria-hidden="true" />
                        NTAK
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {(this.hasRole([
              'KEDVEZMENY_KEDVEZMENY',
              'KEDVEZMENY_VKTIPUS',
              'KEDVEZMENY_VK',
              'KEDVEZMENY_VKGEN',
              'KEDVEZMENY_FUNKKEDV'
            ]) || this.hasRoleSpec(['KEDVEZMENY_LISTA_FORGALOM', 'KEDVEZMENY_LISTA_FELHASZNALAS'])) && (
                <li className='nav-item'>
                  <NavLink
                    to={this.getPublicUrl('/admin/kedvezmeny')}
                    className='nav-link'
                    activeClassName='active'
                  >
                    <i className='fa fa-percent' />
                    {'Kedvezmény'}
                  </NavLink>
                </li>
            )}      
            {this.hasRole(['UGYFELSZOLGALAT_ESET', 'UGYFELSZOLGALAT_ALLAPOT', 'UGYFELSZOLGALAT_ELERHETOSEG', 'UGYFELSZOLGALAT_ESETTIPUS']) && (
              <li className={this.activeRoute('/admin/ugyfelszolgalat')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='fa fa-commenting-o' />
                  {'Ügyfélszolgálat'}
                </a>
                <ul className='nav-dropdown-items'>
                  {
                    this.hasRole(['UGYFELSZOLGALAT_ESET']) &&
                    (
                      <li className='nav-item'>
                        <NavLink
                          to={this.getPublicUrl('/admin/ugyfelszolgalat/esetek')}
                          className='nav-link'
                          activeClassName='active'
                        >
                          &emsp;
                            <i className='fa fa-archive' aria-hidden='true'></i>
                          Esetek
                        </NavLink>
                      </li>
                    )
                  }
                  {this.hasRole(['UGYFELSZOLGALAT_ALLAPOT', 'UGYFELSZOLGALAT_ELERHETOSEG', 'UGYFELSZOLGALAT_ESETTIPUS']) && (
                    <li className='nav-item'>
                      <NavLink to={this.getPublicUrl('/admin/ugyfelszolgalat/torzsadatok')} className='nav-link' activeClassName='active'>
                        &emsp; <i className='fa fa-folder-o' />
                        Törzsadatok
                        </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {this.hasRole(['HIRLEVEL_HIRLEVEL']) && (
                <li className='nav-item'>
                  <NavLink
                    to={this.getPublicUrl('/admin/hirlevelkezeles')}
                    className='nav-link'
                    activeClassName='active'
                  >
                    <i className='fa fa-envelope' />
                    {'Hírlevélkezelés'}
                  </NavLink>
                </li>
            )}
            {this.hasRole(['BLOG_BLOG'], true) && (
              <li className='nav-item'>
                <NavLink
                  to={this.getPublicUrl('/admin/blog')}
                  className='nav-link'
                  activeClassName='active'
                >
                  <i className='fa fa-newspaper-o' />
                  {'Blog'}
                </NavLink>
              </li>
            )}
            {this.hasRole(['PARTNER_TORZS', 'PARTNER_CSOPORT', 'GDPR_NAPLO', 'GDPR_PROFIL', 'GDPR_JOGALAP']) && (
              <li className={this.activeRoute('/admin/partner')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='icon-people' />
                  {'Partner'}
                </a>
                <ul className='nav-dropdown-items'>
                  {(this.hasRole(['PARTNER_TORZS', 'PARTNER_CSOPORT'])) && (
                    <li className='nav-item'>
                      <NavLink to={this.getPublicUrl('/admin/partner/partnertorzs')} className='nav-link' activeClassName='active'>
                        &emsp;<i className='fa fa-users' aria-hidden='true'></i>
                        Partner törzs
                        </NavLink>
                    </li>
                  )}
                  {this.hasRole(['GDPR_NAPLO']) && (
                      <li className='nav-item'>
                        <NavLink
                          to={this.getPublicUrl('/admin/partner/GDPR')}
                          className='nav-link'
                          activeClassName='active'
                        >
                          &emsp;
                            <i className='fa fa-calendar' />
                          GDPR
                        </NavLink>
                      </li>
                    )
                  }
                  {this.hasRole(['GDPR_PROFIL', 'GDPR_JOGALAP']) && (
                      <li className='nav-item'>
                        <NavLink
                          to={this.getPublicUrl('/admin/partner/GDPR_beallitasok')}
                          className='nav-link'
                          activeClassName='active'
                        >
                          &emsp;
                            <i className='fa fa-cog' aria-hidden='true'></i>
                          GDPR beállítások
                        </NavLink>
                      </li>
                    )
                  }
                </ul>
              </li>
            )}
            {(this.hasRole([
              'CIKK_TORZS',
              'CIKK_CSOPORT',
              'CIKK_PROFIL',
              'CIKK_AFA',
              'TELEPULES_ORSZAG',
              'TELEPULES_TELEPULES',
              'RAKTAR_RAKTAR',
              'BIZONYLAT_TOMB',
              'BIZONYLAT_TIPUS',
              'PENZUGYKOZOS_PENZNEM',
              'PENZUGYKOZOS_FIZMOD',
              'PENZUGYKOZOS_INFLACIO',
              'PENZUGYKOZOS_BANKTIPUS',
              'PENZUGYKOZOS_BANKSZAMLA',
              // 'BANK_PENZTAR',
              // 'MUNKALAP',
              // 'KARTOTEK_VIZSGALO',
              'HELYSZIN_HELYSZIN',
              'HELYSZIN_TEREM',
              'JEGYTERMEK_SZEKTOR',
              'HELYSZIN_KULSOKLIENS',
              'SZERVEZET_SZEMELYI',
              'CEGADAT_CEGADAT',
              'IDOPONT_DOLGOZO',
              'IDOPONT_SZOLGALTATAS',
              'NAPTAR_NAPTAR_ESEMENY_TIPUS'
            ]) || this.hasRoleSpec(['IDOPONT_KAPCSOLO']) || this.hasRole(['CONFIG_USER'], true)) && (
                <li className={this.activeRoute('/admin/torzsadatok')}>
                  <a
                    className='nav-link nav-dropdown-toggle nav-head'
                    onClick={this.handleClick.bind(this)}
                  >
                    <i className='fa fa-folder-o' />
                    {'Törzsadatok'}
                  </a>
                  <ul className='nav-dropdown-items'>
                    {this.hasRole(['CIKK_TORZS', 'CIKK_CSOPORT', 'CIKK_AFA', 'CIKK_PROFIL']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/cikk')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                        <i className='fa fa-shopping-bag' />
                            {'Cikk'}
                          </NavLink>
                        </li>
                      )}
                      {this.hasRole(['TELEPULES_ORSZAG', 'TELEPULES_TELEPULES']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/foldrajziegyseg')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                        <i className='icon-location-pin' />
                            {'Földrajzi egységek'}
                          </NavLink>
                        </li>
                      )
                    }
                    {this.hasRole(['RAKTAR_RAKTAR']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/raktar')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                        <i className='fa fa-cubes' />
                            {'Raktár'}
                          </NavLink>
                        </li>
                      )}
                      {this.hasRole(['BIZONYLAT_TOMB', 'BIZONYLAT_TIPUS']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/bizonylatkezeles')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                        <i className='fa fa-edit' />
                            {'Bizonylatkezelés'}
                          </NavLink>
                        </li>
                      )}
                      {this.hasRole([
                        // 'PENZUGYKOZOS_FIZMOD',
                        // 'PENZUGYKOZOS_PENZNEM',
                        'PENZUGYKOZOS_INFLACIO',
                        'PENZUGYKOZOS_BANKTIPUS',
                        'PENZUGYKOZOS_BANKSZAMLA',
                        // 'BANK_PENZTAR',
                        'PENZUGYKOZOS_FIZMOD',
                        'PENZUGYKOZOS_PENZNEM'
                      ]) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/penzugy')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                        <i className='icon-wallet' />
                            {'Pénzügyi adatok'}
                          </NavLink>
                        </li>
                      )}
                      {this.hasRole(['HELYSZIN_HELYSZIN', 'HELYSZIN_TEREM', 'JEGYTERMEK_SZEKTOR', 'HELYSZIN_KULSOKLIENS']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/helyszin')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                          <i className='fa fa-building-o' />
                            {'Helyszín'}
                          </NavLink>
                        </li>
                      )}
                      {this.hasRole(['SZERVEZET_SZEMELYI']) && (
                        <li className='nav-item'>
                          <NavLink to={this.getPublicUrl('/admin/torzsadatok/szemelyitorzs')} className='nav-link' activeClassName='active'>
                            &emsp;
                            <i className='fa fa-address-card-o' />
                            {'Személyi törzs'}
                          </NavLink>
                        </li>
                      )}
                      {this.hasRole(['CEGADAT_CEGADAT']) && (
                        <li className='nav-item'>
                          <NavLink
                            to={this.getPublicUrl('/admin/torzsadatok/cegadatok')}
                            className='nav-link'
                            activeClassName='active'
                          >
                            &emsp;
                            <i className='fa fa-building-o' />
                            Cégadatok
                          </NavLink>
                        </li>
                      )}
                       {this.hasRole(['CONFIG_USER'], true) && (
                      <li className='nav-item'>
                        <NavLink to={this.getPublicUrl('/admin/torzsadatok/felhasznalok')} className='nav-link' activeClassName='active'>
                          &emsp;
                          <i className='fa fa-user' />
                          Felhasználók
                        </NavLink>
                      </li>
                    )}
                    {(this.hasRole(['IDOPONT_DOLGOZO', 'IDOPONT_SZOLGALTATAS']) || this.hasRoleSpec(['IDOPONT_KAPCSOLO'])) && (
                      <li className='nav-item'>
                        <NavLink to={this.getPublicUrl('/admin/torzsadatok/idopontfoglalo')} className='nav-link' activeClassName='active'>
                          &emsp;
                          <i className='fa fa-calendar-o' />
                          {'Időpontfoglaló'}
                        </NavLink>
                      </li>
                    )}
                    {this.hasRole(['NAPTAR_NAPTAR_ESEMENY_TIPUS']) && (
                      <li className="nav-item">
                        <NavLink to={this.getPublicUrl('/admin/torzsadatok/naptar')} className="nav-link" activeClassName="active">
                          &emsp;  
                          <i className="fa fa-calendar-o" />
                          Naptár
                        </NavLink>
                      </li>
                    )}
                  </ul>
                </li>
            )}
            {(this.hasRole(['RENDELES_SZALLITOI', 'RENDELES_AJANLAT', 'RENDELES_VEVOI', 'RENDELES_EMAILSABLON']) || this.hasRoleSpec(['RENDELES_BEALLITAS']))
            && (
              <li className={this.activeRoute('/admin/rendelesek')}>
                <a className="nav-link nav-dropdown-toggle nav-head" onClick={this.handleClick.bind(this)}>
                  <i className="fa fa-truck" />
                  {'Rendelések'}
                </a>
                <ul className="nav-dropdown-items">
                  {(this.hasRole(['RENDELES_SZALLITOI', 'RENDELES_AJANLAT', 'RENDELES_VEVOI']) || this.hasRoleSpec(['RENDELES_BEALLITAS'])) && (
                    <li className="nav-item">
                      <NavLink to={this.getPublicUrl("/admin/rendelesek/rendeles")} className="nav-link" activeClassName="active">
                        <i className="icon-envelope-letter" />
                        {'Rendelés'}
                      </NavLink>
                    </li>
                  )}
                  {this.hasRole(['RENDELES_EMAILSABLON']) && (
                    <li className="nav-item">
                      <NavLink to={this.getPublicUrl("/admin/rendelesek/email")} className="nav-link" activeClassName="active">
                        <i className="fa fa-envelope-o" />
                        {'Email sablonok'}
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
              {this.hasRole(['MUNKALAP_OSSZ']) && (
              <li className="nav-item">
                <NavLink to={this.getPublicUrl("/admin/munkalap")} className="nav-link" activeClassName="active">
                  <i className="icon-docs" />
                  {'Munkalap'}
                </NavLink>
              </li>
            )}
            {this.hasRole(['KARBANTARTAS_KARBANTARTAS', 'KARBANTARTAS_ALKALOM', 'KARBANTARTAS_ELLENORZESILISTA']) && (
              <li className="nav-item">
                <NavLink to={this.getPublicUrl("/admin/karbantartas")} className="nav-link" activeClassName="active">
                  <i className="fa fa-wrench" />
                  {'Karbantartás'}
                </NavLink>
              </li>
            )}
            {this.hasRole(['FELADATLISTA_FELADAT', 'FELADATLISTA_FELADATTIPUS']) && (
              <li className="nav-item">
                <NavLink to={this.getPublicUrl("/admin/feladatlista")} className="nav-link" activeClassName="active">
                  <i className="fa fa-file-text-o" />
                  {'Feladatlista'}
                </NavLink>
              </li>
            )}
             {/* {(true) && (
              // {(this.hasRole(['TEREMBERLES_TEREMBERLES']) || this.hasRoleSpec(['TEREMBERLES_FIZ_KARB'])) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/rendelesek/rendeles')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        <i className='fa fa-ticket' />
                        Rendelések
                        </NavLink>
                    </li>
            )} */}
            
            {this.hasRoleSpec(['KULTIK_BUFE', 'KULTIK_PROMOCIOK', 'KULTIK_TEVEKENYSEG', 'KULTIK_EXTRACONTENT']) && (
              <li className={this.activeRoute('/admin/weboldalak')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='fa fa-globe' />
                  Kultik Weboldalak
                </a>
                <ul className='nav-dropdown-items'>
                  {this.hasRoleSpec(['KULTIK_BUFE']) && (
                    <li className='nav-item'>
                      <NavLink to={this.getPublicUrl('/admin/weboldalak/bufekinalat')} className='nav-link' activeClassName='active'>
                        &emsp;<i className='fa fa-cutlery' />
                        Büfé kínálat
                        </NavLink>
                    </li>
                  )}
                  {this.hasRoleSpec(['KULTIK_PROMOCIOK']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/weboldalak/promociok')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                          <i className='fa fa-list-alt' />
                        Promóciók
                        </NavLink>
                    </li>
                  )}
                  {this.hasRoleSpec(['KULTIK_TEVEKENYSEG']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/weboldalak/tevekenysegek')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                          <i className='fa fa-list-alt' />
                        Tevékenységek
                        </NavLink>
                    </li>
                  )}
                  {this.hasRoleSpec(['KULTIK_EXTRACONTENT']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/weboldalak/extra')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                          <i className='fa fa-file-text' />
                        Extra tartalom
                        </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              )}
              {this.hasRole(['NAPTAR_NAPTAR']) && (
              <li className="nav-item">
                <NavLink to={this.getPublicUrl('/admin/naptar')} className="nav-link" activeClassName="active">
                  <i className="fa fa-calendar-o" aria-hidden="true" />
                  Naptár
                </NavLink>
              </li>
            )}
            {this.hasRole(['SZAMLAZAS_NYUGTA']) && (
              <li className={this.activeRoute('/admin/szamlazas')}>
                <a className="nav-link nav-dropdown-toggle nav-head" onClick={this.handleClick.bind(this)}>
                  <i className="fa fa-usd" />
                  Számlázás
                </a>
                <ul className="nav-dropdown-items">
                  {this.hasRole(['SZAMLAZAS_NYUGTA']) && (
                    <li className="nav-item">
                      <NavLink to={this.getPublicUrl('/admin/szamlazas/nyugta')} className="nav-link" activeClassName="active">
                        &emsp;
                        <i className="fa fa-sticky-note-o" aria-hidden="true" />
                        Nyugták
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            {(this.hasRole(['IDOPONT']) || this.hasRoleSpec(['IDOPONT_STATISZTIKA'])) && (
              <li className={this.activeRoute('/admin/idopont')}>
                <a
                  className='nav-link nav-dropdown-toggle nav-head'
                  onClick={this.handleClick.bind(this)}
                >
                  <i className='fa fa-calendar-o' />
                Időpontfoglalás
            </a>
                <ul className='nav-dropdown-items'>
                  {this.hasRole(['IDOPONT']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/idopont/idopontfoglalo')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                      <i className='fa fa-calendar-o' />
                        {'Időpontfoglaló'}
                      </NavLink>
                    </li>
                  )}
                  {this.hasRoleSpec(['IDOPONT_STATISZTIKA']) && (
                    <li className='nav-item'>
                      <NavLink
                        to={this.getPublicUrl('/admin/idopont/lekerdezes')}
                        className='nav-link'
                        activeClassName='active'
                      >
                        &emsp;
                        <i className='fa fa-bar-chart' />
                        Lekérdezés
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
            )}
            
          </ul>
        </nav>
      </div>
    );
  }
}

Sidebar.propTypes = {
  globals: PropTypes.object,
  keycloak: PropTypes.object,
  location: PropTypes.object,
};

export default Sidebar;
